import React from 'react';
import { Grid } from '@material-ui/core';
import {
  string,
  objectOf,
  arrayOf,
  bool,
  node,
  oneOfType,
} from 'prop-types';
import ColumnSection from '../ColumnSection';
import DefaultParagraph from '../../typeface/DefaultParagraph';
import DefaultPreamble from '../../typeface/DefaultPreamble';
import variables from '../../styles/variables.module.scss';
import styles from './style.module.scss';

const InfoColumnSection = ({
  headlineSmall,
  headlineLarge,
  stroke,
  title,
  body,
  data,
  backgroundColor,
  textColor,
  headlineLineBreak,
  isCase,
}) => (
  <ColumnSection
    headlineLarge={headlineLarge}
    headlineSmall={headlineSmall}
    stroke={stroke}
    title={title}
    body={body}
    backgroundColor={backgroundColor}
    textColor={textColor}
    headlineLineBreak={headlineLineBreak}
    isCase={isCase}
  >
    <div className={styles.container}>
      <Grid container direction="row">
        {
          data && Object.keys(data).map((value) => {
            const infoPoints = data[value].map(val => (
              <DefaultParagraph
                key={val}
                style={{ color: textColor }}
                small
                className={styles.subTitle}
              >
                {val}
              </DefaultParagraph>
            ));
            return (
              <Grid key={value} item xs={12} sm>
                <DefaultPreamble className={styles.title} style={{ color: textColor }}>{value}</DefaultPreamble>
                {infoPoints}
              </Grid>
            );
          })
        }
      </Grid>
    </div>
  </ColumnSection>
);

InfoColumnSection.propTypes = {
  headlineSmall: string,
  headlineLarge: string,
  stroke: string,
  title: oneOfType([
    string,
    node,
  ]),
  body: oneOfType([
    string,
    node,
  ]),
  backgroundColor: string,
  textColor: string,
  data: objectOf(arrayOf(String)),
  headlineLineBreak: bool,
  isCase: bool,
};

InfoColumnSection.defaultProps = {
  headlineSmall: null,
  headlineLarge: null,
  stroke: null,
  title: null,
  body: null,
  data: null,
  backgroundColor: variables.tuna,
  textColor: variables.cleanWhite,
  headlineLineBreak: true,
  isCase: false,
};

export default InfoColumnSection;
